/* eslint-disable no-param-reassign */
import { useParams } from "react-router-dom";
import { CATEGORIES_ENUMS } from "constants/navigation/categories";
import { useLocalizationStore } from "stores/localization";

export interface IUseGetParam {
  lang: string;
  category: string;
  game: string;
}

const CATEGORIES_ENUMS_VALUES = Object.values(CATEGORIES_ENUMS) as string[];

const INIT_PARAMS: IUseGetParam = {
  lang: "",
  category: "",
  game: "",
};

export const useGetParam = (): IUseGetParam => {
  const urlParams = useParams<Record<string, string | undefined>>();
  const availableLangs = useLocalizationStore((s) => s.languages);
  const langCodes = new Set(availableLangs.map((l) => l.isoCode.toLowerCase()));

  const urlValues = Object.values(urlParams).filter(
    (v): v is string => typeof v === "string",
  );

  return urlValues.reduce<IUseGetParam>(
    (acc, value) => {
      const val = value.toLowerCase();

      if (CATEGORIES_ENUMS_VALUES.includes(val)) {
        acc.category = val;
      } else if (langCodes.has(val)) {
        acc.lang = val;
      } else {
        acc.game = val;
      }

      return acc;
    },
    { ...INIT_PARAMS },
  );
};
